// extracted by mini-css-extract-plugin
module.exports = {"section":"Store_section__zWSFr","header":"Store_header__mtA3w","list":"Store_list__1-akc","svg":"Store_svg__3riCR","div":"Store_div__2fHme"};